import React from "react";
import Colors from "../../config/Colors";

export function SortIcon({
  height,
  width,
  viewBox = "0 0 24 24",
  svgColor = `${Colors.secondaryColor}`,
}: CustomSVGProp) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox || "0 0 24 24"}
      fill="none"
    >
      {/* Top line - longest (full width) */}
      <rect
        x="2"
        y="4.5"
        width="20"
        height="3"
        fill={svgColor || "#000000"}
        rx="1.5"
      />
      {/* Middle line - medium length (centered) */}
      <rect
        x="5"
        y="10.5"
        width="14"
        height="3"
        fill={svgColor || "#000000"}
        rx="1.5"
      />
      {/* Bottom line - shortest (centered) */}
      <rect
        x="8"
        y="16.5"
        width="8"
        height="3"
        fill={svgColor || "#000000"}
        rx="1.5"
      />
    </svg>
  );
}

export default SortIcon;
